import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import styles from "./privacy.module.css";

const PrivacyPolicy = () => {
  return (
    <Container className={styles.privacyPage}>
      <Row>
        <Col md={12}>
          <h2><strong>Privacy Policy</strong></h2><br/>
          <p>
<strong>Updated as of August 1, 2023</strong>
          </p>
          <p>
        We at KUR are committed to protecting your Personal Information (defined below). As such, we maintain information confidentiality and comply with applicable regulatory requirements.
          </p>
          <p>
          This privacy policy ("Privacy Policy") covers our online privacy practices with respect to use and/or disclosure of information we may collect from you when you access or use our website ("Website"), and any other websites or documents we may provide that reference this Privacy Policy (collectively, our "Services"). The Services are provided by KUR International, LLC through one or more of its affiliates (“KUR,” "we," "us," or "our"). This Privacy Policy does not apply to information collected through other means, such as by telephone or in person or by other third parties that are not part of our Services. Please review our privacy practices, email our privacy team, or write to us at the address below if you have any questions.
          </p>
          <h4><strong><u>Contact Information:</u></strong></h4>
          <p>
            KUR International, LLC
            <br />
            Attention: VP of Legal
            <br />
            2425 Cedar Springs Road
            <br />
            Dallas, Texas 75201
            <br />
            {/* <a href="mailto:legal@kurr.com">legal@kurr.com</a> */}
            legal@kurr.com
          </p>
          <p>
            This Privacy Policy <strong>does not apply to information that would be considered “Protected Health Information”</strong> under the Health Insurance Portability and Accountability Act of 1996 (“HIPAA”). 
          </p>
          <section>
            <h4><strong><u>Information Collected through the Website</u></strong></h4>
            <p>
              Our Website may include pages that permit you the opportunity to
              provide us with Personal Information about yourself. As used in
              this Privacy Policy, “Personal Information” means any information
              that may be used, either alone or in combination with other
              information, to personally identify an individual as defined by
              applicable state laws as noted below.
            </p>
            <strong>
              We collect certain information, including Personal Information,
              from and about our Website users in three ways:
            </strong>
            <ul>
              <li>Directly from you; </li>
              <li> Directly from our web server logs; or </li>
              <li>Cookies and web beacons.</li>
            </ul>
          </section>
          <section>
            <h4><strong><u>Information Provided by You</u></strong></h4>  
            <p>
              We and our service providers collect Personal Information through online forms to provide certain features of the Services to you. For example, if applying for a job through the Website, we may request you to fill out a form with information such as your name, e-mail address, phone number, and work experience. If you do not provide the information required to submit the forms, we may not be able to provide you with related features and services.
            </p>
            <p>
             In some cases, you may have the opportunity to enter into our secure forms any content that you choose. You are responsible for such content and we reserve the right to use such content as part of our Services.
            </p>
            <h4><strong><u>Web Server Logs</u></strong></h4>
            When you access or use our Services,
            we may track information to administer our Services and analyze its
            usage. Examples of information we may track include, without
            limitation:
            <ul>
              <li>Your Internet protocol address;</li>
              <li> The kind of browser or computer you use; </li>
              <li>Number of links you click within our Services;</li>
              <li>State or country from which you accessed our Services;</li>
              <li>Date and time of your visit;</li>
              <li>Name of your Internet service provider;</li>
              <li>Third party websites you linked to from our Services; and</li>
              <li>Pages or information you viewed on our Services.</li>
            </ul>
            We use this information to analyze and improve our Services, monitor
            traffic and usage patterns for information security purposes, and to
            help make our Services more useful.
          </section><br/>
          <section>
            <h4><strong><u>Cookies and Web Beacons</u></strong></h4>
            <p>
              A “cookie” is a small text file that may be transferred to your
              computer’s hard drive to personalize our services for you and
              collect information regarding usage of our Services. Each computer
              is assigned a different cookie that contains a random, unique
              identifier. 
              <br />Your browser software can be set to warn you of
              cookies or reject all cookies. Most browsers offer instructions on
              how to reset the browser to reject cookies in the “Help” section
              of the toolbar. If you reject our cookies, this may disable some
              of the functionality of our Services and you may not be able to
              use certain services.
            </p>
            <p>
              We may display content from third party platforms or services that
              allow you to view their hosted content directly from the pages of
              our Siteand interact with them. The use of your
              PersonalInformation by a third party depends on the privacy policy
              of that third party. 
              <br />A “web beacon,” “clear GIF,” “web bug,” or
              “pixel tag” is a tiny graphic file with a unique identifier that
              is similar in function to a cookie that allows us to count the
              number of users who have visited certain pages or screens of our
              websites, and to help determine the effectiveness of promotional
              or advertising campaigns. When used in HTML-formatted email
              messages, web beacons can tell the sender whether and when the
              email has been opened. In contrast to cookies, which may be stored
              on your computer’s hard drive, web beacons are typically embedded
              invisibly on pages or screens. We may use web beacons in providing
              the Services.
            </p>
          </section>
          <section>
            <h4><strong><u>The Purposes for Which We Use Personal Information</u></strong></h4>
            <p>
              Your Personal Information may be used in the following ways: (i)
              to provide, analyze, administer, and improve our Services; (ii) to
              contact you in connection with our Services and appointments,
              events or offerings that you may have registered for; (iii) to
              identify and authenticate your access to password-protected
              Services that you are authorized to access; (iv) to send you
              communications that you have authorized; (v) for recruiting and
              human resources administration purposes; (vi) to protect our
              rights or our property and to ensure the technical functionality
              and security of our Services; and (vii) as required to meet our
              legal and regulatory obligations.
              <br /><br/> If you are a resident of the
              European Economic Area and you have questions about or need
              further information concerning the legal basis on which we collect
              and use your information, please contact our privacy team.
            </p>
          </section>
          <section>
            <h4><strong><u>How We Disclose Personal Information</u></strong></h4>
            <p>
             We do not sell, lease, rent or otherwise disclose the Personal Information collected from our Site to third parties unless otherwise stated below or with your consent.
            </p>
            <ul>
              <li>
                <strong>Our Third Party Providers.</strong> We transfer Personal
                Information to third party service providers to perform tasks on
                our behalf and to assist us in providing our Services. For
                example, we may use third party service providers for security,
                website analytics, and payment processing. We use commercially
                reasonable efforts to only engage or interact with third party
                service providers and partners that post a privacy policy
                governing their processing of Personal Information, and require
                our service providers to maintain confidentiality and comply
                with applicable laws in the processing of Personal Information.
              </li>
              <li>
                <strong>
                  In the Event of Merger, Sale, Divestitures, or Change of
                  Control.
                </strong>{" "}
                We may transfer or assign Personal Information to a third party
                entity that acquires or is merged with us as part of a merger,
                acquisition, sale, or other change of control.
              </li>{" "}
              <li>
                <strong>Other Disclosures.</strong> We may disclose Personal Information about you if we have a good faith belief that disclosure of such information is helpful or reasonably necessary to: (i) comply with any applicable law, regulation, legal process or governmental request; (ii) enforce our terms of use, including investigations of potential violations thereof; (iii) detect, prevent, or otherwise address fraud or security issues; or (iv) protect against harm to our or third parties' rights, property or safety.
              </li>
              <li>
                <strong>Partners.</strong> We may share Personal Information with marketing, treatment, or health care operations support partners, who are also required to protect the confidentiality of your information, that will enable them to send you targeted messages or serve you targeted advertising, which will occur with your authorization or otherwise in compliance with HIPAA (defined above) and other applicable laws.
              </li>
            </ul>
            {/* <p>
              To prevent unauthorized sharing of user data, we have the following controls in
              place:
            </p>
            <ul>
              <li>
                <strong>Access Controls:</strong> System access is role-based and limited to authorized personnel
                only. User access is reviewed and updated as part of onboarding, role changes,
                and termination processes.
              </li>
              <li>
                <strong>Offboarding Controls:</strong> We have a formal offboarding process in place that includes
                timely deactivation of system access and credentials upon employee separation.
              </li>
              <li>
                <strong>Vendor-Level Security:</strong> For platforms such as GoTo Connect, data is protected using
                vendor-provided security measures, including encryption in transit and at rest,
                consistent with their standard security framework.
              </li>
              <li>
                <strong>Administrative Oversight:</strong> Administrative access is restricted, and changes to permissions
                are managed centrally.
              </li> */}
            {/* </ul> */}
          </section>
          <section>
            <h4><strong><u>Retention of Information</u></strong></h4>
            <p>
              We will retain Personal Information for the period necessary to
              fulfill the purposes for which it has been collected as described
              in this Privacy Policy unless a longer retention period is
              required by law, for security, fraud & abuse prevention, to comply
              with legal or regulatory requirements, to ensure continuity of
              services, or for financial record-keeping purposes.
            </p>
          </section>
          <section>
            <h4><strong><u>User Communications</u></strong></h4>
            <ul>
              <li>
                Email communications that you send to us via the email links on
                our Services may be shared with a customer service
                representative, employee, or agent that is most able to address
                your inquiry. Once we have responded to your communication, it
                is discarded or archived, depending on the nature of the inquiry
                and all applicable laws, rules and regulations.
              </li>{" "}
              <li>
                The email functionality on our Services does not provide a
                completely secure and confidential means of communication. It is
                possible that your email communication may be accessed or viewed
                by another Internet user while in transit to us.
              </li>
            </ul>
          </section>
          <section>
            <h4><strong><u>Your Rights - Personal Information</u></strong></h4>
            <p>
              If you would like to access, amend, erase, export, object to,
              restrict the processing, or otherwise restrict the Personal
              Information collected via our Services, or make any other request
              as described below by State law, you may email our privacy team or
              write to us at:
            </p>
            <p>
              KUR International, LLC
              <br />
              Attention: VP, Legal
              <br />
              2425 Cedar Springs Road
              <br />
              Dallas, Texas 75201
              <br />
              {/* <a href="mailto:legal@kurr.com">legal@kurr.com</a> */}
              legal@kurr.com
            </p>
            <p>
              We will promptly review all such requests in accordance with
              applicable laws.
            </p>
            <p>
              Depending on where you live, you may have a right to lodge a
              complaint with a supervisory authority or other regulatory agency
              if you believe that we have violated any of the rights concerning
              Personal Information about you. We encourage you to first contact
              us so we have an opportunity to address your concerns directly
              before you do so.
            </p>
          </section>
          <section>
            <h4><strong><u>Communications Opt-Out</u></strong></h4>
            <p>
              We may send certain messages, including electronic newsletters and
              marketing communications, on a periodic basis. If you wish to be
              removed from such messages, you may request to discontinue future
              ones. All such material will have information as to how to opt-out
              of receiving it, although certain messages may be required by law
              and will not have opt-out capabilities.
            </p>
          </section>
          <section>
            <h4><strong><u>State-Specific Privacy Rights</u></strong></h4>
            <p>
              You may have a number of rights related to Personal Information
              that we process about you depending on the jurisdiction where you
              reside and the legal basis that we use. Please refer to the
              state-specific sections below for more information about your
              rights.
            </p>
            <section>
              <h5><strong><em>California Residents</em></strong></h5>
              <p>
                The California Consumer Privacy Act (“CCPA”), as amended by the
                California Privacy Rights Act (“CPRA”), provides California
                residents with the following rights regarding their Personal
                Information:
              </p>
              <ul>
                <li>
                  The right to know what Personal Information we have collected,
                  used, disclosed and sold about you, including the categories
                  of Personal Information, the categories of sources from which
                  the Personal Information is collected, the business or
                  commercial purpose for collecting, selling, or sharing
                  personal information, the categories of third parties to whom
                  we disclose Personal Information, and the specific pieces of
                  Personal Information we have collected about you.{" "}
                </li>
                <li>
                  The right to correct inaccuracies in your Personal
                  Information, taking into account the nature of the Personal
                  Information and the purposes of the processing.
                </li>
                <li>
                  The right to request deletion of Personal Information we have
                  collected about you.
                </li>
                <li>
                  The right to opt out of the selling or sharing of your
                  Personal Information, which you can exercise through the
                  contact formavailable on our website or by modifying your
                  privacy preferences (e.g., Global Privacy Control), available
                  through certain internet browsers and extensions, that signal
                  your preference to opt out. Please note that clearing your
                  cookies at any time will remove the signal of your selected
                  privacy preferences.
                </li>
                <li>
                  The right to limit the use of your sensitive Personal
                  Information, which you can exercise through the contact
                  formavailable on our website.
                </li>
              </ul>
              <p>
                In addition to the rights listed above, California's <strong><em>"Shine the Light"</em></strong> law <em>(Cal. Civ. Code § 1798.83)</em> permits users who are residents of California to request certain information regarding our disclosures of Personal Information to third parties for such third parties' direct marketing purposes. Please email or write to our privacy team as provided above to submit your request.
              </p>
            </section>
            <section>
              <h5><strong><em>Colorado Residents</em></strong></h5>
              <p>
                Starting in July 2023, the Colorado Privacy Act ("CPA") provides
                Colorado residents with the following rights regarding their
                Personal Information:
              </p>
              <ul>
                <li>
                  The right to confirm whether we process your Personal
                  Information and access your Personal Information in a portable
                  and readily usable format.
                </li>
                <li>
                  The right to correct inaccuracies in your Personal
                  Information, taking into account the nature of the Personal
                  Information and the purposes of the processing.
                </li>
                <li>
                  The right to delete Personal Information we have obtained
                  about you.
                </li>
                <li>
                  The right to opt out of the processing of your Personal
                  Information for purposes of targeted advertising, the sale of
                  Personal Information, and/or profiling in furtherance of
                  decisions that produce legal or similarly significant effects.
                </li>
                <li>
                  If we deny your request, the right to appeal our decision.
                </li>
              </ul>
            </section>
            <section>
              <h5><strong><em>Connecticut Residents</em></strong></h5>
              <p>
                Starting in July 2023, the Connecticut Data Privacy Act
                (“CTDPA”) provides Connecticut residents with the following
                rights regarding their Personal Information:
              </p>
              <ul>
                <li>
                  The right to confirm whether we process your Personal
                  Information and access your Personal Information in a portable
                  and, to the extent technically feasible, readily usable
                  format.
                </li>
                <li>
                  The right to correct inaccuracies in your Personal
                  Information, taking into account the nature of the Personal
                  Information and the purposes of the processing.
                </li>
                <li>
                  The right to delete Personal Information provided by or
                  obtained about you.
                </li>
                <li>
                  The right to opt out of the processing of your Personal
                  Information for purposes of targeted advertising, the sale of
                  Personal Information, and/or profiling in furtherance of
                  solely automated decisions that produce legal or similarly
                  significant effects.
                </li>
                <li>
                  If we deny your request, the right to appeal our decision.
                </li>
              </ul>
            
              <h5><strong><em>Utah Residents</em></strong></h5>
              <p>
                Starting in December 2023, the Utah Consumer Privacy Act
                (“UCPA”) will provide Utah residents with the following rights
                regarding their Personal Information:
              </p>

              <ul>
                <li>
                  The right to know what Personal Information we have collected,
                  used, or disclosed about you.
                </li>
                <li>
                  The right to request that we delete any Personal Information
                  we have collected from you.
                </li>
                <li>
                  The right to obtain a copy of the Personal Information you
                  have previously provided to us in a format that, to the extent
                  technically feasible, is portable and readily usable.
                </li>
              </ul>
            </section>
            <section>
              <h5><strong><em>Virginia Residents</em></strong></h5>
              <p>
                The Virginia Consumer Data Protection Act (“VCDPA”) provides
                Virginia residents with the following rights regarding their
                Personal Information:
              </p>
              <ul>
                <li>
                  The right to confirm whether we process your Personal
                  Information and access your Personal Information.
                </li>
                <li>
                  The right to correct inaccuracies in your Personal
                  Information, taking into account the nature of the Personal
                  Information and the purposes of the processing.
                </li>
                <li>
                  The right to delete Personal Information we have obtained
                  about you.
                </li>
                <li>
                  The right to opt out of the processing of your Personal
                  Information for purposes of targeted advertising, the sale of
                  Personal Information, and/or profiling in furtherance of
                  decisions that produce legal or similarly significant effects.
                </li>
                <li>
                  The right to obtain a copy of the Personal Information you
                  have previously provided to us in a portable and, to the
                  extent technically feasible, readily usable format.
                </li>
                <li>
                  If we deny your request, the right to appeal our decision.
                </li>
              </ul>
            </section>
          </section>
          <section>
            <h4><strong><u>How to Make a Request</u></strong></h4>
            <p>
              To make any of the requests described above, you may contact us at
              (866) 300-5380 or submit the request using the Contact Form
              available on our website at https://kurr.com/contact.
            </p>
            <p>
              Residents of California may also designate an authorized agent to
              make a request on their behalf. Parents may also make verifiable
              requests on behalf of their minor children.
            </p>
            <ul>
              The verifiable request must:
              <li>
                Provide sufficient information that allows us to reasonably
                verify you are the person about whom we collected Personal
                Information or an authorized representative.
              </li>
              <li>
                Describe your request with sufficient detail that allows us to
                properly understand, evaluate, and respond to it.
              </li>
            </ul>
            <p>
              We cannot respond to your request or provide you with Personal
              Information if we cannot verify your identity or authority to make
              the request and confirm the Personal Information relates to you.
              We will use Personal Information provided in a verifiable request
              only to verify the requestor’s identity or authority to make the
              request.
            </p>
          </section>{" "}
          <section>
            <h4><strong><u>Verifiable Request Response Timing and Format</u></strong></h4>
            <p>
              We endeavor to respond to a verifiable request within forty‑five
              (45) days of its receipt. If we require more time (up to an
              additional forty‑five (45) days), we will inform you of the reason
              and extension period in writing. With the exception of disclosures
              to California residents, any disclosures we provide will cover
              only the twelve (12) month period preceding the verifiable
              request’s receipt. The response we provide will also explain the
              reasons we cannot comply with a request, if applicable. For data
              portability requests, we will select a format to provide your
              Personal Information that is readily useable and should allow you
              to transmit the information from one entity to another entity
              without hindrance. We do not charge a fee to process or respond to
              your verifiable request unless it is excessive, repetitive, or
              manifestly unfounded. If we determine that the request warrants a
              fee, we will tell you why we made that decision and provide you
              with a cost estimate before completing your request.
            </p>
          </section>
          <section>
            <h4><strong><u>Appeal of Verifiable Request Response</u></strong></h4>
            <p>
              Residents of Colorado, Connecticut, and Virginia have the right to
              appeal a decision we make regarding their requests. To appeal a
              decision we make regarding your request, please contact us as
              described under Contact Information above.
            </p>
          </section>
          <section>
            <h4><strong><u>Retention Period</u></strong></h4>
            <p>
              We will retain your Personal Information for as long as needed or
              permitted for the purpose(s) for which it was obtained. The
              criteria to determine retention periods include: (i) length of
              time of ongoing relationship with you, (ii) legal obligation to
              which we are subject or industry standards; (iii) quantity, nature
              and sensitivity of Personal Information; (iv) potential risk of
              harm in the event of unauthorized use or disclosure; and (v) the
              purpose of the processing and whether or not these purposes can be
              achieved by other means.
            </p>
          </section>
          <section>
            <h4><strong><u>Non-Discrimination</u></strong></h4>
            <p>
              We will not discriminate against you for exercising any of your
              rights related to your Personal Information. Unless permitted by
              applicable laws, we will not:
            </p>
            <ul>
              <li>Deny you goods or services.</li>
              <li>
                Charge you different prices or rates for goods or services,
                including through granting discounts or other benefits, or
                imposing penalties.
              </li>
              <li>
                Provide you a different level or quality of goods or services.
              </li>
              <li>
                Suggest that you may receive a different price or rate for goods
                or services or a different level or quality of goods or
                services.
              </li>
            </ul>
          </section>
          <section>
            <h4><strong><u>Modifications and Updates to Privacy Policy</u></strong></h4>
            <p>
              KUR may update and modify this Privacy Policy at any time, and
              such updates and modifications will be effective immediately upon
              posting the updated or modified Privacy Policy. You agree to
              review this Privacy Policy periodically to be aware of such
              updates and modifications and your continued access or use of the
              Web Site after any updates and modifications will be deemed your
              conclusive acceptance of the updated or modified Privacy Policy.
            </p>
          </section>
          <br />
          <p style={{ textAlign: 'left' }}>
            © Copyright KUR International, LLC – August 2023
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;
